export default __webpack_public_path__ + "static/media/cer18.575b5130.png";